import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { XIcon } from '../common/Icons';

interface Props {
    open?: boolean;
    onClose?(open: boolean): void;
    title?: string;
    description?: string;
    children: any;
}

export default function AlertModal({
    open,
    onClose,
    title,
    description,
    children,
}: Props) {
    return (
        <AlertDialog.Root open={open} onOpenChange={onClose}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay className="fixed inset-0 z-50 bg-black bg-opacity-25" />
                <AlertDialog.Content className="fixed top-1/2 left-1/2 z-50 m-auto flex max-h-[100vh] w-11/12 max-w-[486px] -translate-y-2/4 -translate-x-2/4 transform flex-col rounded bg-white text-left align-middle transition-all md:w-full md:max-w-fit">
                    <div className="relative py-[14px] px-[10px] xs:p-6">
                        <XIcon
                            onClick={() => {
                                onClose?.(false);
                            }}
                            className="absolute right-5 top-5 hidden h-4 w-4 transition-colors hover:cursor-pointer hover:text-primary sm:block"
                        />
                        {title && (
                            <div className="mr-2 text-xl font-medium lg:text-2xl">
                                {title}
                            </div>
                        )}
                        {description && (
                            <div className="mt-2 text-sm font-normal text-[#898899]">
                                {description}
                            </div>
                        )}
                        {children}
                    </div>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
}
